import { InnerBlocks } from '@wordpress/block-editor';

/**
*  This is the save function and markup for the callout box block.
**/

function Save({ attributes }) {

  return (
    <div className="biobox" role="complementary">
      <InnerBlocks.Content />
    </div>
  );
}

export default Save;
